import { usePopup } from "hooks/usePopup";
import stockRuleService from "services/stockRuleService";

import { StyledDrawer } from "../styles";
import { RuleForm } from "./RuleForm";

export const RuleDrawer = ({
  open,
  close,
  initialValues,
  productList,
  onSaved
}) => {
  const { addPopup } = usePopup();
  const isEditing = !!initialValues;

  const onSubmit = async data => {
    try {
      if (isEditing) {
        await stockRuleService.update(initialValues.id, {
          strategy: data.strategy,
          starts_at: data.startsAt,
          ends_at: data.endsAt,
          observation: data.observation
        });
      } else {
        await stockRuleService.create(data);
      }

      addPopup({
        type: "success",
        title: `Regra ${isEditing ? "atualizada" : "criada"} com sucesso.`
      });
      close();
      onSaved();
    } catch (error) {
      addPopup({
        type: "error",
        title:
          error?.response?.data?.message ||
          error?.response?.data?.detail ||
          "Erro ao salvar regra de estoque."
      });
    }
  };

  return (
    <StyledDrawer
      anchor="right"
      open={open}
      onClose={close}
      title={isEditing ? "Editar regra de estoque" : "Nova regra de estoque"}
    >
      <RuleForm
        initialValues={initialValues}
        productList={productList}
        onSubmit={onSubmit}
        isEditing={isEditing}
      />
    </StyledDrawer>
  );
};
